import { clsx } from 'clsx';
import { CircleAlert } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';

export interface FieldErrorProps extends Omit<ComponentPropsWithoutRef<'p'>, 'children'> {
  /** The error text (e.g. `errors.email?.message` from React Hook Form). Renders nothing when empty. */
  message?: string | undefined;
}

/**
 * Specific, human error text under a field — with an icon so colour is never the only cue.
 * Give it an `id` and reference it from the control's `aria-describedby`.
 */
export function FieldError({ message, className, ...props }: FieldErrorProps) {
  if (!message) return null;
  return (
    <p role="alert" className={clsx('field-error', className)} {...props}>
      <CircleAlert size={16} aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
